import React, { Component } from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

class Mockup extends Component {

  render() {
  	const { website, alignment } = this.props

    return (
      <section className={`mockup mockup--${alignment}`}>
        <div className='mockup__frame'>
          <svg width="1920px" height="1180px" viewBox="0 0 1920 1180" version="1.1" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
            <g className="mockup__fill" fillRule="nonzero">
              <path d="M1542,170v840H378V170H1542z M1920,0H0v1180h1920V0z"/>
            </g>
          </svg>
        </div>
        <div className={`mockup__${alignment}`}>
          <div className='mockup__wrapper'>
            <div className='mockup__content'>
              <GatsbyImage image={getImage(website.localFile)} alt={website.altText} />
            </div>
          </div>
        </div>
      </section>
    )
  }
}

Mockup.defaultProps = {
  website: null,
  alignment: 'website',
}

export default Mockup
